const SOCIAL_CLASS_NAMES = Object.freeze(['.social--footer', '.footer-info-social', '.social-media-links'])

const handleClickTracker = (event) => {
  const target = event.currentTarget;

  if (target.dataset.varsEventClickable === 'false') {
    return
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'social_profile_click',
    click_destination: target.href,
  });
}

const elementIterator = (el) => {
  el.addEventListener('click', handleClickTracker)
}

export const setGTMClickEventTracker = () => {
  const linkBlocks = document.querySelectorAll(SOCIAL_CLASS_NAMES);
  if (linkBlocks.length > 0) {
    linkBlocks.forEach(block => {
      block.childNodes.forEach(elementIterator);
    })
  }
}
